import { Button, Tab, Tabs, Typography } from '@material-ui/core';
import { useGenericStyles } from 'common/genericStyles';
import { FuncaoParticipante, InvestidorResponse, Perfil, TipoInvestidor } from 'common/genericTypes';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { LgSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RootState } from 'store';
import { InvestidorDocumentos } from './documentos';
import { InvestidorInformacoesPrincipais } from './informacoesPrincipais';
import { InvestidorRepresentantesLegais } from './representantesLegais';
import FundoInvestidorDetails from './fundoInvestidor';

type ComponentParams = { investidorId: string };

type Props = RouteComponentProps<ComponentParams>;

const DetalhesInvestidor: React.FC<Props> = (props) => {
  const { investidorId } = props.match.params;
  const classes = useGenericStyles();
  const [tabValue, setTabValue] = useState<number>(0);
  const [investidor, setInvestidor] = useState<InvestidorResponse>();

  const dispatch = useDispatch();
  const getInvestidorApi = useSelector((state: RootState) => state.investidorApi.getInvestidor);
  const isParticipanteCustodiante =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Custodiante;
  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);

  const getInvestidor = useCallback(async () => {
    try {
      const result = await getInvestidorApi(dispatch, investidorId, true);
      setInvestidor(result);
    } catch (error) {
      console.log(error);
    }
  }, [dispatch, getInvestidorApi, investidorId]);

  useEffect(() => {
    getInvestidor();
  }, [getInvestidor]);

  const isFundoInvestidor = investidor?.tipo === TipoInvestidor.Fundo;

  return (
    <div style={{ marginRight: 40 }}>
      <Typography className={classes.wrapTxt} variant="h1">{`${isFundoInvestidor ? 'Fundo Investidor' : 'Investidor'} ${investidor?.razaoSocial || ''}`}</Typography>
      <LgSpace />
      
      {isFundoInvestidor ? (
        <FundoInvestidorDetails investidorId={investidorId} />
      ) : (
        <>
          <HorizontalAppBar>
            <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
              <Tab label="Informações Principais" />
              <Tab label="Representante Legal/Procurador" />
              <Tab label="Documentos" />
            </Tabs>
          </HorizontalAppBar>
          {tabValue === 0 && investidor && <InvestidorInformacoesPrincipais investidor={investidor} />}
          {tabValue === 1 && investidor && (
            <InvestidorRepresentantesLegais representantesLegais={investidor.representantesLegais} />
          )}
          {tabValue === 2 && investidor && <InvestidorDocumentos investidor={investidor} />}
        </>
      )}
      
      <LgSpace />
      <div style={{ textAlign: 'center', marginRight: '20px' }}>
        {isParticipanteCustodiante && !isUsuarioLeitura && (
          <Button
            onClick={() => {
              if (isFundoInvestidor) {
                props.history.push(`/gerenciar/investidores/editar/${investidor?.id}?tipo=fundo`);
              } else {
                props.history.push(`/gerenciar/investidores/editar/${investidor?.id}`);
              }
            }}
            variant="contained"
            color="primary"
            style={{ margin: '10px' }}
          >
            {'Editar'}
          </Button>
        )}
      </div>
      <LgSpace />
    </div>
  );
};

export default withRouter(DetalhesInvestidor);
